import { applyMiddleware, compose, createStore } from 'redux';

import middlewares from './middlewares';
import rootReducer from './reducer';

function createStoreEnhancers() {
  if (process.env.PREACT_APP_ENVIRONMENT === 'development') {
    const composeEnhancers = (typeof window !== 'undefined' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) || compose;
    return composeEnhancers(applyMiddleware(...middlewares));
  }

  return applyMiddleware(...middlewares);
}

const store = createStore(rootReducer, createStoreEnhancers());

if (module.hot) {
  module.hot.accept('./reducer', () => {
    // eslint-disable-next-line global-require
    const { default: nextRootReducer } = require('./reducer');
    store.replaceReducer(nextRootReducer);
  });
}

export default store;
